import { Box, CircularProgress, MenuItem, TextField } from "@mui/material";
import { DbUser } from "../../../../interfaces";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

type TeacherSelectProps = {
  teacherId: string;
  onChange: (id: string) => void;
  options: DbUser[];
  disabled: boolean;
  required: boolean;

  isLoading?: boolean;
};

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function TeacherSelect(props: TeacherSelectProps) {
  const emptyAndDisabled = !props.teacherId && props.disabled;
  const classes = useStyle();
  const { isLoading = false } = props;
  return (
    <TextField
      className={classes.inputText}
      value={props.teacherId}
      onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disabled}
      label="Teacher"
      required={props.required}
      InputLabelProps={{
        shrink: emptyAndDisabled || undefined,
      }}
      SelectProps={{
        displayEmpty: true,
        // Renders 'N/A' without actually setting the value
        renderValue: emptyAndDisabled ? () => "N/A" : undefined,
      }}
      fullWidth
      select>
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {props.options.map((teacher) => (
        <MenuItem key={teacher.id} value={teacher.id}>
          {teacher.full_name}
        </MenuItem>
      ))}
    </TextField>
  );
}
